import { useNavigate } from "react-router-dom";
import { Button } from "@allaria-tech/matter/Button";
import { Icon } from "@allaria-tech/matter/Icon";
import { Typography } from "@allaria-tech/matter/Typography";

import Layout from "../Layout/Layout";

import styles from "./NotFoundPage.module.scss";

const NotFoundPage = () => {
  const { page, card, body, iconWrapper, iconCircle, text, footer } = styles;

  const navigate = useNavigate();

  return (
    <Layout centeredLogo hideStepper>
      <div className={page}>
        <div className={card}>
          <div className={body}>
            <div className={iconWrapper}>
              <span className={iconCircle}>
                <Icon
                  name="search"
                  size={29}
                  color="var(--icon-emphasis, #2b58a1)"
                />
              </span>
            </div>
            <div className={text}>
              <Typography type="HEADING" size="M" tag="h1">
                No encontramos esta página
              </Typography>
              <Typography type="BODY" size="S">
                El link puede estar roto o el contenido ya no existe. Volvé al
                inicio para seguir navegando.
              </Typography>
            </div>
          </div>
          <div className={footer}>
            <Button text="Volver al inicio" onClick={() => navigate("/")} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
